import { AppInitialStateType, actionTypes, AppInitialState, AppReducer } from "./app-reducer";
import React, { createContext, useContext, useMemo, useReducer } from "react";

type Action = {
  type: keyof typeof actionTypes
  payload: any
}

const AppContext = createContext<{
  state: AppInitialStateType;
  dispatch: React.Dispatch<Action>;
}>({
  state: AppInitialState,
  dispatch: () => null
});

export interface ContextValueType {
  state: AppInitialStateType;
  dispatch: React.Dispatch<Action>;
}

export const AppWrapper = ({ children }: { children: React.ReactElement }) => {
  const [state, dispatch] = useReducer(AppReducer, AppInitialState);
  const contextValue: ContextValueType = useMemo(() => {
    return { state, dispatch }
  }, [state, dispatch]);

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
}

export const useAppContext = () => {
  return useContext(AppContext);
}